module.exports = __webpack_public_path__ + "static/media/W19-0046_299_Mama_Cheese_Desktop_2396x1473_en.038253a7.jpg";